import { API_FETCH_USER_DATA_SUCCESS } from 'root/src/client/logic/api/actionIds'

export default (body, recordType) => ({
	type: API_FETCH_USER_DATA_SUCCESS,
	payload: { body, recordType },
})
